<script lang="ts">
  let { delay = 0 }: { delay?: number } = $props()
</script>

<!-- A single diagonal foil shine sweeping across the parent, once. -->
<div class="sweep-host" aria-hidden="true">
  <div class="bar" style:animation-delay="{delay}ms"></div>
</div>

<style lang="postcss">
  .sweep-host {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    overflow: hidden;
    pointer-events: none;
  }
  .bar {
    position: absolute;
    top: -20%;
    bottom: -20%;
    left: 0;
    transform: translateX(-160%) skewX(-18deg);
    animation: sweep 900ms ease-in-out forwards;
    background: linear-gradient(
      90deg,
      transparent,
      oklch(100% 0 0 / 0.55),
      transparent
    );
    width: 45%;
    mix-blend-mode: screen;
  }
  @keyframes sweep {
    to {
      transform: translateX(340%) skewX(-18deg);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .bar {
      display: none;
    }
  }
</style>
